// ============================================================================
// Baixar/abrir arquivo de rota AUTENTICADA (fetch + blob)
// ============================================================================
// ⚠️⚠️ POR QUE ISTO EXISTE, e por que não se usa `<a href>` para rota de arquivo:
//    quando o navegador busca um recurso POR URL (`<a href>`, `<img src>`,
//    `<iframe src>`, `<video src>`), ele **não manda o header `Authorization`**.
//    O JWT do portal vive no `localStorage` e só entra na requisição quando é o
//    NOSSO código que a faz. Link direto para rota protegida volta **401** — foi
//    exatamente assim que os anexos de nota fiscal do Compras pararam de abrir
//    (card no PLANO › Trilho A).
//
//    A alternativa seria o link assinado de curta validade (o que o vídeo do
//    Financeiro usa, porque `<video>` só aceita URL). Ela foi DESCARTADA para
//    documento com dado pessoal: o token vai na query, e query fica no log do
//    Nginx e no histórico do navegador — além de a permissão ser conferida uma
//    única vez, na emissão, em vez de a cada leitura.
//
// ⚠️ `blob:` em celular: abrir em aba nova é irregular no Android. Por isso
//    `abrirArquivoComToken` cai para DOWNLOAD quando a aba é bloqueada — melhor
//    o arquivo na pasta de downloads do que um clique que não faz nada.
//
// ⚠️ `revokeObjectURL` é obrigatório: sem ele o arquivo fica preso na memória
//    da aba até o reload. No caminho de "abrir", a revogação é ADIADA — revogar
//    na hora fecharia o visualizador que acabou de abrir.
// ============================================================================

// Busca o arquivo mandando o token. Devolve { blob, nomeArquivo }.
// Erro do servidor vem como JSON — é o que permite mostrar "sem permissão" em
// vez de um PDF quebrado.
async function buscarArquivo(url) {
  const token = localStorage.getItem('authToken');
  const resp = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!resp.ok) {
    const dados = await resp.json().catch(() => ({}));
    throw new Error(dados.message || `Não foi possível abrir o arquivo (HTTP ${resp.status}).`);
  }
  // O nome vem do Content-Disposition do servidor; o `padrao` é só a rede de segurança.
  const disp = resp.headers.get('Content-Disposition') || '';
  const casa = disp.match(/filename="?([^"]+)"?/i);
  return { blob: await resp.blob(), nomeArquivo: casa ? casa[1] : null };
}

/**
 * Baixa o arquivo (vai para a pasta de downloads).
 * @param {string} url      rota autenticada do arquivo
 * @param {string} [padrao] nome a usar se o servidor não mandar um
 */
export async function baixarArquivoComToken(url, padrao = 'arquivo') {
  const { blob, nomeArquivo } = await buscarArquivo(url);
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = nomeArquivo || padrao;
  // ⚠️ O `<a>` entra no documento antes do clique: o Firefox ignora clique
  //    programático em elemento solto na memória.
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}

/**
 * Abre o arquivo numa aba (visualizador do navegador). Se o navegador bloquear
 * a aba — comum no celular —, baixa em vez de falhar em silêncio.
 * @param {string} url      rota autenticada do arquivo
 * @param {string} [padrao] nome a usar no download de fallback
 */
export async function abrirArquivoComToken(url, padrao = 'arquivo') {
  const { blob, nomeArquivo } = await buscarArquivo(url);
  const href = URL.createObjectURL(blob);
  const aba = window.open(href, '_blank');
  if (!aba) {
    const a = document.createElement('a');
    a.href = href;
    a.download = nomeArquivo || padrao;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
    return;
  }
  // Revogação adiada: fazê-la agora fecharia o visualizador recém-aberto.
  setTimeout(() => URL.revokeObjectURL(href), 60_000);
}
